import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { fg } from '@confluence/feature-gating';

import graphqlHelpersDSPIsActionEnabledForContentQuery, {
	type graphqlHelpersDSPIsActionEnabledForContentQuery$data,
	type graphqlHelpersDSPIsActionEnabledForContentQuery$variables,
} from './__generated__/graphqlHelpersDSPIsActionEnabledForContentQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadIsAttachmentDownloadEnabled = async (
	contentId: string,
	spaceKey: string,
): Promise<{
	data: graphqlHelpersDSPIsActionEnabledForContentQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> => {
	const action = fg('cc-dlp_split-attachment-dl-from-export-dsp')
		? 'ATTACHMENT_DOWNLOAD'
		: 'PAGE_EXPORT';

	const response = await query<
		graphqlHelpersDSPIsActionEnabledForContentQuery$data,
		graphqlHelpersDSPIsActionEnabledForContentQuery$variables
	>({
		query: graphqlHelpersDSPIsActionEnabledForContentQuery,
		variables: {
			action,
			contentId,
			contentStatus: 'CURRENT',
			contentVersion: 1,
			spaceKey,
		},
	});

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const { mediaConfigEnforceDSPRecorder } = await import(
			/* webpackChunkName: "loadable-confluencessr-utilities-objectrecorder" */ '@confluence/ssr-utilities/entry-points/ObjectRecorder.ts'
		);
		const isAttachmentDownloadAllowed =
			response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed || false;
		// When attachment download is not allowed, enforce the data security policy
		mediaConfigEnforceDSPRecorder.set(!isAttachmentDownloadAllowed);
	}

	return response;
};
